import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//Calendar
import calendar from "./calendar/reducer"

//catalog items
import Catalog from "./catalogItems/reducer"

// departments
import Department from "./Departments/reducer"

// categories
import Category from "./Categories/reducer"

//shifts
import Shift from "./Shifts/reducer"

//teams
import Team from "./Teams/reducer"

// team unaAvailability
import TeamUnAvailability from "./TeamUnAvailability/reducer"

// checklist
import Checklist from "./Checklists/reducer"

//workorderItems list
import WorkOrderItem from "./WorkOrderItems/reducer"

// cancellation list
import Cancellation from "./Cancellation/reducer"

// Notification list 
import Notification from "./Notification/reducer"

// team members list
import TeamMember from "./TeamMembers/reducer"

// feedback list
import Feedback from "./feedbacks/reducer"

// users
import User from "./Users/reducer"

// customers
import Customer from "./Customers/reducer"

// permissions
import Permission from "./Permissions/reducer"

// roles
import Role from "./Roles/reducer"

//addresses
import Address from "./Address/reducer"

// workorders
import WorkOrder from "./WorkOrders/reducer"

// Holidays
import Holidays from "./Holidays/reducer"

// branches
import Branch from "./branch/reducer"

// site survey
import SiteSurvey from "./SiteSurvey/reducer"

// solution
import Solution from "./solutions/reducer"

// sebel user
import SebelUser from "./sebelUsers/reducer"

// zone 
import Zone from "./Zones/reducer";

// Areas
import Area from "./Areas/reducer"

const rootReducer = combineReducers({
  Cancellation,
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  Catalog,
  Department,
  Category,
  Shift,
  Team,
  TeamUnAvailability,
  Checklist,
  WorkOrderItem,
  Notification,
  TeamMember,
  Feedback,
  User,
  Customer,
  Permission,
  Role,
  Address,
  WorkOrder,
  Holidays,
  Branch,
  Solution,
  SiteSurvey,
  SebelUser,
  Zone,
  Area
})

export default rootReducer
